import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Form from '../../../2_Molecules/Form/Form'
import Input from '../../../1_Atoms/Forms/Input/Input'
import Select from '../../../1_Atoms/Forms/Select/Select'
import { useForm } from '../../../../hooks/useForm'
import { languageController } from '../../../../controllers/language/languageController'
import Button from '../../../1_Atoms/Button/Button'
import { Svg } from '../../../1_Atoms/Svg/Svg'
import { handleRequest } from '../../../../utils/httpRequest'
import { getEndpointUrl } from '../../../../utils/endPoints'
import parse from 'html-react-parser';

function VehicleInformationStep_BaSA({
  handleNextStep,
  topText
}) {
  const [modelData, setModalData] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [modelYearOptions, setModelYearOptions] = useState([]);

  const initState = {
    model: '',
    modelYear: '',
    vin: '',
    kilometers: ''
  }

  const validations = {
    model: ['required'],
    modelYear: ['required'],
    vin: ['vin', 'isAlphaNumeric'],
    kilometers: ['odometer', 'positive'],
  }

  useEffect(() => {
    async function fetchMazdaModels() {
      try {
        // Get all the models including legacy models.
        // TODO: Check if legacy ones are included once it's implemented in BE.
        const res = await handleRequest('get', getEndpointUrl('model-years') + '&includeLegacy=TRUE');

        if (res.status === 200 && res.data) {
          const modelList = res.data['model_years'];

          if (!modelList) return;

          setModalData(modelList)

          const mappedModelList = modelList.map(modelData => ({
            id: modelData.carline.id,
            title: modelData.carline.title,
          }));

          // Remove models that have duplicate id.
          const uniqueModelLists =
            Array.from(new Set(mappedModelList.map(a => a.id)))
              .map(id => mappedModelList.find(a => a.id === id));

          // Set model options with a data-attribute to be attached to option el.
          setModelOptions(uniqueModelLists.map(item => ({
            value: item.title,
            label: item.title,
            ['data-model-id']: item.id
          })));
        }
      } catch (err) {
        console.log(err)
      }
    }
    // get the model list from the api.
    fetchMazdaModels()
  }, [])

  const { handleSubmit, handleChange, data, errors } = useForm({
    initState,
    validations,
    onSubmit: () => {
      handleNextStep({ vehicleData: data })
    },
  })

  const handleModelYears = (modelId) => {
    if (!modelData) return;
    // Get model data that has the passed model id.
    const modelYearsData = modelData.filter(model => model.carline.id === modelId);

    if (modelYearsData.length > 0) {
      setModelYearOptions(modelYearsData.map(modelData => ({
        value: modelData.year.title,
        label: modelData.year.title,
      })));
    }
  }

  const { model, modelYear, vin, kilometers } = data;

  return (
    <div className="mz-vehicle-information-step-basa">
      <div className="mz-container">
        <div className="grid-inner-content">
          <div className="mz-vehicle-information-step-basa__top">
            {
              topText && parse(topText)
            }
          </div>
          {
            modelOptions.length > 0 && (
              <Form
                onSubmit={handleSubmit}
                isDark={false}
                noValidate={true}
              >
                <Select
                  name="model"
                  // label={languageController.getFormCopy('label', '')} // TODO: Needs a label?
                  placeholder={languageController.getFormCopy('placeholder', 'model2')}
                  value={model}
                  isRequired={true}
                  errorMessage={errors.model}
                  onChange={(e) => {
                    // Get model id on the selected option.
                    const modelId = e.target[e.target.selectedIndex].getAttribute('data-model-id')
                    handleChange(e)
                    handleModelYears(modelId)
                  }}
                  options={modelOptions}
                />
                <Select
                  name="modelYear"
                  // label={languageController.getFormCopy('label', '')} // TODO: Needs a label?
                  placeholder={languageController.getFormCopy('placeholder', 'modelYear')}
                  value={modelYear}
                  isRequired={true}
                  errorMessage={errors.modelYear}
                  onChange={handleChange}
                  options={modelYearOptions}
                  disabled={(!modelYearOptions.length > 0)}
                />
                <Input
                  type="number"
                  name="kilometers"
                  label={languageController.getFormCopy('label', 'kilometers')}
                  value={kilometers}
                  errorMessage={errors.kilometers}
                  onChange={(e) => {
                    // Handle max length
                    if (e.target.value.length <= 7) {
                      handleChange(e)
                    }
                  }}
                />
                <Input
                  type="text"
                  name="vin"
                  label={languageController.getFormCopy('label', 'vin')}
                  value={vin}
                  errorMessage={errors.vin}
                  onChange={handleChange}
                  maxLength={17}
                />
                <Button
                  type="submit"
                  className="mz-btn--primary mz-btn--red"
                  label={languageController.getCopy('global', 'continue')}
                  buttonIcon={<Svg type="chevron_small" size={0.8} colour="white" style={{ top: '1px' }} />}
                  buttonIconPosition="right"
                  disabled={(!modelYear || !model)}
                />
              </Form>
            )
          }
        </div>
      </div>
    </div>
  )
}

VehicleInformationStep_BaSA.propTypes = {
  handleNextStep: PropTypes.func.isRequired
}

export default VehicleInformationStep_BaSA